import { render, staticRenderFns } from "./signup.vue?vue&type=template&id=ffbbefe2&scoped=true&"
import script from "./signup.vue?vue&type=script&lang=js&"
export * from "./signup.vue?vue&type=script&lang=js&"
import style0 from "./signup.vue?vue&type=style&index=0&id=ffbbefe2&prod&lang=scss&"
import style1 from "./signup.vue?vue&type=style&index=1&id=ffbbefe2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbbefe2",
  null
  
)

export default component.exports